<template>
  <svg xmlns="http://www.w3.org/2000/svg" height="100%" viewBox="0 0 7.071 7.071">
    <g id="Group_1318" data-name="Group 1318" transform="translate(-1.464 -2.301)">
      <rect id="line" width="8" height="2" rx="1" transform="translate(1.464 7.957) rotate(-45)" />
      <rect id="line-2" data-name="line" width="8" height="2" rx="1" transform="translate(7.121 9.372) rotate(-135)" />
    </g>
  </svg>
</template>
<script>
export default {
  name: "M4CloseSvg"
};
</script>
